<template>
  <div class="sm-search-input">
    <input
      :placeholder="placeholder ? placeholder : 'Поиск'"
      v-model="syncValue"
    />
    <SearchIcon class="search-icon" />
  </div>
</template>
<script>
import SearchIcon from '@/assets/icons/search'
export default {
  name: 'SmSearchInput',
  components: { SearchIcon },
  props: {
    placeholder: String,
    value: String
  },
  data() {
    return {}
  },
  computed: {
    syncValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'style.scss';
</style>
